export const BUSINESS_CATEGORY_OPTIONS = [
  {
    value: '1',
    label: 'School (150 or more students)',
  },
  {
    value: '2',
    label: 'School (less than 150 students)',
  },
  {
    value: '3',
    label: 'Teacher',
  },
  {
    value: '4',
    label: 'Shop',
  },
] as const
